import React from "react";
import { motion } from "framer-motion";
import { Compass } from "lucide-react";

const L = {
  en: "Guide WA",
  fr: "Guide WA",
  de: "WA Guide",
  it: "Guida WA",
  es: "Guía WA",
  pt: "Guia WA",
};

/** Floating "Guide WA" pill anchored bottom-left.
 *  Positioned opposite the SupportWidget (bottom-right) so the two don't collide.
 */
export function FloatingGuideButton({ lang = "en", onOpen }) {
  const label = L[lang] || L.en;
  return (
    <motion.button
      onClick={onOpen}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: 1.2 }}
      className="fixed bottom-4 left-4 z-40 inline-flex items-center gap-2 bg-[#D95D39] hover:bg-[#C24F2E] text-white font-bold rounded-full pl-3 pr-4 py-2.5 shadow-2xl hover:shadow-3xl transition-all"
      data-testid="floating-guide-btn"
      aria-label={label}
    >
      <span className="w-7 h-7 rounded-full bg-white/20 flex items-center justify-center">
        <Compass className="w-4 h-4" />
      </span>
      <span className="text-xs sm:text-sm whitespace-nowrap">{label}</span>
    </motion.button>
  );
}
